import { useSetAtom } from 'jotai';

import { VisitorDrawerState, preSessionVibesOpenAtom, visitorDrawerStateAtom } from '../../state';
import { useBackgroundMusicPlayback } from '../background-action/useBackgroundMusicPlayback';
import { ReflectionTopicsCta } from './ReflectionTopicsCta';

export function ReflectionTopicsCtaWrapper() {
  const setPreSessionVibesOpen = useSetAtom(preSessionVibesOpenAtom);
  const setDrawerState = useSetAtom(visitorDrawerStateAtom);
  const { handlePlay } = useBackgroundMusicPlayback();
  const openPreSessionVibes = () => {
    setDrawerState(null);
    setPreSessionVibesOpen(true);
    handlePlay();
  };
  const openReflectionTopicsDrawer = () => {
    setDrawerState(VisitorDrawerState.REFLECTION_TOPICS);
  };
  return (
    <ReflectionTopicsCta
      openPreSessionVibes={openPreSessionVibes}
      openReflectionTopicsDrawer={openReflectionTopicsDrawer}
    />
  );
}
